import { forwardRef } from "react";
import type { SVGIconProps } from "../types";

export const OsOthersIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_307"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_307)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 14.1178C8.8034 14.1178 9.59893 13.9596 10.3412 13.6521C11.0834 13.3447 11.7578 12.894 12.3259 12.3259C12.894 11.7578 13.3447 11.0834 13.6521 10.3412C13.9596 9.59893 14.1178 8.8034 14.1178 8C14.1178 7.1966 13.9596 6.40106 13.6521 5.65882C13.3447 4.91657 12.894 4.24215 12.3259 3.67406C11.7578 3.10597 11.0834 2.65534 10.3412 2.34789C9.59893 2.04044 8.8034 1.8822 8 1.8822C6.37746 1.8822 4.82137 2.52675 3.67406 3.67406C2.52675 4.82137 1.8822 6.37746 1.8822 8C1.8822 9.62254 2.52675 11.1786 3.67406 12.3259C4.82137 13.4732 6.37746 14.1178 8 14.1178ZM8 14.5C9.72391 14.5 11.3772 13.8152 12.5962 12.5962C13.8152 11.3772 14.5 9.72391 14.5 8C14.5 6.27609 13.8152 4.62279 12.5962 3.40381C11.3772 2.18482 9.72391 1.5 8 1.5C6.27609 1.5 4.62279 2.18482 3.40381 3.40381C2.18482 4.62279 1.5 6.27609 1.5 8C1.5 9.72391 2.18482 11.3772 3.40381 12.5962C4.62279 13.8152 6.27609 14.5 8 14.5ZM4.5589 6.27945V5.89725L8 3.79385L11.4411 5.89725V6.27945L8 8.3822L4.5589 6.27945ZM5.3233 6.08835L8 4.5589L10.6767 6.08835L8 7.6178L5.3233 6.08835ZM6.85275 5.70615L7.4267 5.3233L9.3377 6.47055L8.7644 6.85275L6.85275 5.70615ZM4.55825 7.61715V8.1911L8 10.1027L11.4411 8.19175V7.6178L8 9.52945L4.55825 7.61715ZM4.55825 10.1027V9.52945L8 11.4411L11.4411 9.52945V10.1027L8 12.015L4.55825 10.1027Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

OsOthersIcon.displayName = "OsOthersIcon";
